import update from './update';
import create from './create';
import remove from './delete';

export default {
  create,
  update,
  remove,
};
